import { footerLinks, footerAbout } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-primary-500">
                91<span className="text-foreground-900">免费</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {footerAbout}
            </p>
            <p className="text-xs text-foreground-400">
              91免费看片神器 · 免费看片大全 · 高清观影平台
            </p>
          </div>

          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60">
          <h4 className="text-sm font-semibold text-foreground-900 mb-3">合作伙伴</h4>
          <p className="text-sm text-foreground-500">优质内容与技术服务伙伴持续加入中</p>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 91免费看片网站. 本站为免费影视资源聚合平台，内容来源于公开网络。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</a>
            <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}